import { gql } from '@/__generated__';

export const GATE_MOVEMENT_FRAGMENT = gql(`#graphql
  fragment GateMovementFragment on GateMovement {
    id
    gate {
      id
    }
    operationProgress
    positions
    requestedBy {
      id
      name
    }
    requestedPosition
    startPosition
    finishPosition
    state
    messages {
      id
      type
      payload
      timestamp
    }
  }
`);
